export default __webpack_public_path__ + "a4dc9be41cf42a7c5091f15372886df6.svg";